import React, { useState, useEffect, useRef } from 'react';
import { MdAdd } from 'react-icons/md';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


import TmFilter from '../ReusableComponents/TmFilter';
import AntdModalComp from '../ReusableComponents/AntdModalComp';
import { DeletePopup } from '../ReusableComponents/DeletePopup';
import { toastError, toastSuccess, toastWarn } from '../Toast/ToastComponent';
import SurveyApi from '../../Api/SurveyPeriodApi';
import { getSurveyPeriod } from '../../store/reducers/actionPermission';
import { ACTIVE_STATUS } from '../../constant/constant';

import Addperiod from './Addperiod';
import { SurveyPeriodTableHeader } from '../../constant/tableHeader';
import Loader from '../ReusableComponents/Loader';
import TmMasterTable from '../ReusableComponents/TmMasterTable';
import SearchInput from '../ReusableComponents/SearchInput';

let filterArray = [
  {
    options: ACTIVE_STATUS,
    placeholder: 'Status',
    controlName: 'status',
    input: 'select',
    allowClear: true,
    defaultValue: true,
    size: 'small',
    style: { width: 120 },
    col: 2,
  },
];

const SurveyperiodComp = () => {
  const debounceTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const permission = useSelector(getSurveyPeriod);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalData, setModalData] = useState({});
  const [filterArr, setFilterArr] = useState({
    search: '',
    status: true,
    limit: 100000,
  });
 const hasFetched = useRef(false);
  const [buttonPermission, setButtonPermissions] = useState({
    add: false,
    edit: false,
    delete: false,
    view: false,
  });

  useEffect(() => {
    if (hasFetched.current) return;

  hasFetched.current = true;
    getSurveyPeriodList(filterArr);
  }, []);

  useEffect(() => {
    if (permission) {
      handlePermission();
      console.log("Permission Full Object:", permission);
    }
  }, [permission]);

  const handlePermission = () => {
    if (!permission?.checked) return navigate('/');
    const obj = {};
    permission.actions.forEach((el) => {
      obj[el.statename.toLowerCase()] = el.checked;
    });
    setButtonPermissions(obj);
  };

  const handleSearchChange = (value) => {
    setFilterArr((prev) => ({ ...prev, search: value }));

    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

    debounceTimeoutRef.current = setTimeout(() => {
      getSurveyPeriodList({ ...filterArr, search: value });
    }, 400);
  };

  const handleFilterChange = (obj) => {
    const updated = { ...filterArr, ...obj };
    setFilterArr(updated);
    getSurveyPeriodList(updated);
  };

  const getSurveyPeriodList = async (filters) => {
    try {
      setLoading(true);
      const payload = { ...filters };
      // If status was cleared (null/undefined), remove it to show all
      if (payload.status === null || payload.status === undefined) {
        delete payload.status;
      }
      const res = await SurveyApi.list(payload);

      if (res?.data?.success) {
        const mappedData = res.data.result.map((item, index) => ({
          id: item.id,
          serialNo: index + 1,
          period_name: item.period_name,
          fromMonth: item.fromMonth,
          toMonth: item.toMonth,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          status: item.activeStatus,
        }));

        setData(mappedData);
      } else {
        setData([]);
        toastWarn(res.data.message);
      }
    } catch (err) {
      toastError(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const toggleModal = (type, value) => {
    if (type === 'Close') {
      setModal(false);
      setModalData({});
      return;
    }

    if (type === 'Add') {
      setModalHeader('Add Survey Period');
      setModalData({ mode: 'add' });
    }

    if (type === 'Edit' && value) {
      setModalHeader('Edit Survey Period');
      setModalData({
        id: value.id,
        period_name: value.period_name,
        fromMonth: value.fromMonth,
        toMonth: value.toMonth,
        activeStatus: value.status,
        mode: 'edit',
      });
    }

    if (type === 'View' && value) {
      setModalHeader('View Survey Period');
      setModalData({
        id: value.id,
        period_name: value.period_name,
        fromMonth: value.fromMonth,
        toMonth: value.toMonth,
        activeStatus: value.status,
        mode: 'view',
      });
    }

    setModal(true);
  };

  const callDelete = async (id) => {
    await DeletePopup(async (canDelete) => {
      if (canDelete)
        try {
          const res = await SurveyApi.delete(id);
          if (res.data.success) {
            toastSuccess(res.data.message);
            getSurveyPeriodList(filterArr);
          } else toastWarn(res.data.message);
        } catch (err) {
          toastError(err?.message || 'Something went wrong');
        }
    });
  };

  return (
    <div>
   
      <div className="d-md-flex align-items-center mb-2">
        <h5 className="mb-0">Survey Period</h5>

        <div className="ms-auto d-flex align-items-center">
          <div className="me-2">
            <SearchInput
              placeholder="Search"
              value={filterArr.search}
              onSearchChange={handleSearchChange}
            />
          </div>

          {buttonPermission.add && (
            <Button
              type="primary"
              icon={<MdAdd size={20} />}
              onClick={() => toggleModal('Add')}
            />
          )}
        </div>
      </div>

      {/* Filter */}
      <div className="mt-2 mb-2">
        <TmFilter
          filterArray={filterArray}
          handleFilterChange={handleFilterChange}
        />
      </div>

      {/* Table */}
      {loading ? (
        <Loader />
      ) : (
        <TmMasterTable
          buttonPermission={buttonPermission}
           modaldata={modalData}
          rows={data}
          columns={SurveyPeriodTableHeader}
          custom={['action', 'checkbox']}
          toggleModal={toggleModal}
          handleDelete={callDelete}
        />
      )}

      <AntdModalComp
        width="30%"
        modalOpen={modal}
        toggleModal={() => toggleModal('Close')}
        modalHeader={modalHeader}
        modalBody={
          <Addperiod
            mode={modalData?.mode}
            modaldata={modalData}
            setModal={setModal}
            reload={() => getSurveyPeriodList(filterArr)}
          />
        }
      />
    </div>
  );
};

export default SurveyperiodComp;